<template>
	<div class="list-group border-radius-2 no-border">
		<WidgetHeader link="/messages/list"> {{ $t('messages') }} </WidgetHeader>

		<div v-if="messages.length">
			<Message :message="message" excerptLength="100" v-for="(message, i) in messages" :key="i" />
		</div>
		<div class="list-group-item" v-if="!messages.length">{{ $t('no-new-messages') }}</div>

	</div>
</template>

<script>
import WidgetHeader from "./WidgetHeader";
import Message from "../Message";

export default {
	props: ['limit','unread'],
	components: {
		WidgetHeader,
		Message,
	},
	data() {
		return {
			messages: []
		}
	},
	methods: {
		getMessages(limit, unread) {
			const dataUrl = `${this.$settings.APIBaseURL}/messages/list`;
			this.$cfetch(dataUrl, {
				data: {
					limit ,
					unread
				}
			}).then((json) => {
				if (json.status.toLowerCase() === "success") {
					this.messages = json.messages;
				}
			})
		}
	},
	mounted() {
		this.getMessages(this.limit, this.unread);
	}
};
</script>
